module.exports = __webpack_public_path__ + "static/media/logo_mobile.25e92f1f.svg";